<template> 
    <v-carousel 
      hide-delimiters=""
      interval="5000"
      :height="ch" >
      <!-- <v-carousel-item  
        v-for="(item,i) in items"
        :key="i"
        :src="require(`@/assets/banner/${item.src}`)"
        lazy-src="https://picsum.photos/10/6?image=3"
        />  -->
    </v-carousel>   
</template>

<script> 
export default {
    props:['notShow','chs' ],
    data(){
        return{
            show:true,
            items: [{src:'b1.jpg'},{src:'b1.jpg'},{src:'b1.jpg'},{src:'b1.jpg'}]
        } 
    },
    mounted(){ 
      
    },
    computed:{
          vs(){
              return this.$vuetify.breakpoint
          },
          ch(){ 
            
              let height = 200
              let vs = this.vs
              let name =this.chs
              if (name ==='xs') {
                  height=200
              }else if (name ='sm') {
                    height=300
              }else if (name ='md') {
                    height=300
              }else if (name ='lg') {
                    height=350
              }else if (name ='xl') {
                    height=550
              }
              // console.log(height,name,this.chs);
               
              return  height
          },
          getTitle(){
            return this.$store.getters.getTitle
          },
          // getToolbar(){ 
          //   return this.$store.getters.getToolbar
          // },
          getNot(){
            let not = this.$store.getters.getNotSubToolbar
            this.page = not.notPage 
            return not
          },
        
          user(){ 
            const user = this.$store.getters.getUser 
            return user
          },
          ud(){ 
              const user = this.$store.getters.getUserD
              return user
          },
          loading(){ 
              const loading = this.$store.getters.getLoading
              return loading
          },
          process(){ 
              const process = this.$store.getters.getProcess 
              return process
          },
          error(){ 
              const error = this.$store.getters.getError
              return error
          },
          getCart(){
            return this.$store.getters.getItemCart
          }
         
    },
    methods:{
      
        onSign(){
           this.$emit('onSign')  
        },
        onCart(){
          this.$router.push('/cart')
        }
        

    },
    watch:{
       
       
    }
    

}
</script>
<style>
  .minWith{
    margin: 0;
    min-width: 0;
  }
  .slow {
    transition:.19s ;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(10px);
    opacity: 0;
  }
  
</style>

